import React, { useEffect, useState } from 'react'
import './my-evals-list.styles.scss'

import { UseCloudFunction } from '@/utils/firebase.utils'
import { format } from 'date-fns'
import { Sources } from '@/forms/formTypes'

import { useSelector } from 'react-redux'
import { obfuscateString } from '../../../utils/obfuscation'
import { Link } from 'react-router-dom'
import ThreeDotsLoader from '../../SHARED/loader/three-dots-loader.component'

const MyEvalsList = ({ 
  setPlatform, 
  type, 
  adminData 
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const currentUser = useSelector(state => state.userData.currentUser);
  const [evalList, setEvalList] = useState(null);
  const [localSource, setLocalSource] = useState('none');
  const [ loading, setLoading ] = useState(true);


  useEffect(() => {
    if (userProfile) {
      getMyEvals();
      setPlatform('none')
    }
  }, [userProfile, adminData])

  useEffect(() => {
    console.log('setting type')
    if (type) {
      setPlatform(type)
      setLocalSource(type)
    }
  }, [type])

  async function getMyEvals() {
    const userId = adminData?.ind_cst_key || userProfile.id;
    const res = await UseCloudFunction(
      'getMyEvals',
      { 'cst_key': userId }
    )
    setLoading(false);
    console.log(res)
    setEvalList(res.evalList)

  }

  return (
    <div className='my_evals_list'>

      {
        (currentUser)
          ?
          (loading)
          ?
          <div className='center-col'>
            <ThreeDotsLoader />
          </div>
          :
          (evalList && Object.keys(evalList).length > 0)
            ?
            <div className={`my_evals_list_content ${!adminData ? 'g-card' : ''}`}>
              {
                adminData
                ?
                <>
                <h5>Completed Evaluations</h5>
                <hr />
                </> 
                :
                <>
                <h3>My Previous Evaluations</h3>
                <hr />
                </>
              }
              <table className="uk-table uk-table-striped">
                <thead>
                  <tr>
                    <th>Date Completed</th>
                    <th>Title</th>
                    {
                      (adminData) &&
                      <th>Platform</th>
                    }
                    <th>Type of PD</th>
                    <th>Event Date</th>
                    <th>Evidence</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    Object.values(evalList)
                      .sort((a, b) => (a.ts < b.ts) ? 1 : -1)
                      .map(ev => {
                        const urlString = obfuscateString(JSON.stringify({ 'evalId': ev.evalId, 'cstKey': ev.userId }));
                        if (!ev.platform) {
                          ev.platform = 'eln';
                        }
                        return (
                          (
                            adminData ||
                            localSource === ev.platform
                          )
                          ?
                            <tr key={ev.ts}>
                              <td>{format(new Date(ev.ts), "Pp")}</td>
                              <td>{ev.title}</td>
                              {
                                (adminData) &&
                                <td>{ev.platform.toUpperCase()}</td>
                              }
                              <td>{Sources?.[ev.source]?.title}</td>
                              <td>{(ev.eventDate) ? format(new Date(ev.eventDate), "P") : ''}</td>
                              <td>{
                                (ev.cpduUrl || ev.eoc)
                                  ?
                                  <Link
                                    to={`/print/${urlString}`}
                                    target="_blank">
                                    <button className='g-button small-btn'>
                                      Print
                                    </button>
                                  </Link>
                                  // <Link to={ev.cpduUrl} target="_blank" rel="noopener noreferrer">
                                  // 	Print
                                  // </Link>
                                  : ''
                              }</td>
                            </tr>
                            : null
                        )
                      })
                  }
                </tbody>
              </table>
            </div>
            :
            <h4>No evaluations completed so far...</h4>
          :
          <div>
            <div className='g-height-40'></div>
            <div className='uk-container'>
              <h3 className='center'>Please make sure you are using the correct link to the evaluation.<br />Click "Login" above to see your completed evaluations</h3>
            </div>
          </div>
      }
    </div>
  )
}

export default MyEvalsList;